"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClickEventService = void 0;
var inversify_1 = require("inversify");
var notifyEvents_1 = require("../constants/notifyEvents");
var types_1 = require("../types");
var ClickEventService = /** @class */ (function () {
    function ClickEventService() {
        var _this = this;
        this.isMonitored = false;
        this.clickHandler = function (event) {
            _this.observableService.notify(notifyEvents_1.NOTIFY_CLICK, event);
        };
    }
    ClickEventService.prototype.monitor = function () {
        if (!this.isMonitored) {
            window.addEventListener("click", this.clickHandler, true);
        }
    };
    ClickEventService.prototype.stop = function () {
        window.removeEventListener("click", this.clickHandler, true);
        this.isMonitored = false;
    };
    ClickEventService.prototype.subscribe = function (observer) {
        this.observableService.subscribe(notifyEvents_1.NOTIFY_CLICK, observer);
    };
    ClickEventService.prototype.unsubscribe = function (observer) {
        this.observableService.unsubscribe(notifyEvents_1.NOTIFY_CLICK, observer);
    };
    __decorate([
        (0, inversify_1.inject)(types_1.TYPES.IObservableService),
        __metadata("design:type", Object)
    ], ClickEventService.prototype, "observableService", void 0);
    ClickEventService = __decorate([
        (0, inversify_1.injectable)()
    ], ClickEventService);
    return ClickEventService;
}());
exports.ClickEventService = ClickEventService;
